import React, { FC } from 'react';

import { Button, ButtonProps } from '@lglp/components';

import styles from './StyledButton.module.scss';

export const StyledButton: FC<StyledButtonProps> = (props) => {
  const {
    isCta = false,
    hasBorder = false,
    hasAnimatedBorder = false,
    className,
    ...rest
  } = props;

  return (
    <Button
      className={[
        styles.buttonAction,
        isCta ? styles.buttonAction : '',
        hasBorder ? styles.hasBorderRounded : '',
        hasAnimatedBorder ? styles.hasAnimatedBorderRounded : '',
        className,
      ]}
      {...rest}
    />
  );
};

type StyledButtonProps = ButtonProps & {
  isCta?: boolean;
  hasBorder?: boolean;
  hasAnimatedBorder?: boolean;
};
